module.exports = __webpack_public_path__ + "img/down_bj.262f6ce2.png";